import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles(theme => ({
  root: {
    minWidth: 610,
    minHeight: 240,
    '& div.loading': {
      marginTop: 90
    }
  },
  table: {
  },
  body: {
    maxHeight: 340,
    overflowY: 'auto'
  },
  name: {
    maxWidth: 360,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  count: {
  },
  price: {
  }
}))

export {
  useStyles
}
